/**
 * Matchmaking eligibility — only `active` session players participate in pools,
 * min-games guards, wait metrics, and variety saturation denominators.
 *
 * Paused / signed_up / inactive players may appear on the host UI waitlist but
 * must not affect fairness min, mode, or debt tier medians.
 */

/** @type {Set<string>} */
export const MATCHMAKING_ELIGIBLE_STATUSES = new Set(['active']);

/**
 * @param {string|undefined|null} status
 * @returns {boolean}
 */
export function isMatchmakingEligibleStatus(status) {
  return MATCHMAKING_ELIGIBLE_STATUSES.has(status ?? '');
}

/**
 * @param {string[]} playerIds
 * @param {Record<string, string>} [statusByPlayerId]
 * @returns {string[]}
 */
export function filterMatchmakingEligiblePlayerIds(playerIds, statusByPlayerId = {}) {
  if (!Array.isArray(playerIds)) return [];
  if (!statusByPlayerId || Object.keys(statusByPlayerId).length === 0) {
    return playerIds;
  }
  return playerIds.filter((id) => isMatchmakingEligibleStatus(statusByPlayerId[id]));
}

/**
 * @param {Array<{ player_id?: string, status?: string }>} rows
 * @returns {Record<string, string>}
 */
export function buildStatusMapFromSessionPlayerRows(rows = []) {
  /** @type {Record<string, string>} */
  const map = {};
  for (const row of rows) {
    const id = row?.player_id;
    if (id) {
      map[id] = row.status ?? 'active';
    }
  }
  return map;
}
